import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../../utils/loadable';
import { isFuncComp } from '../../../../components/common/Helpers/index.js';

const vdsRedesignshippingDetails = Loadable(() =>
  isFuncComp() ? import('../../FuncComponnetContainers/shippingDetailsVdsRedesign') : import('../../containers/web/shippingDetailsVdsRedesign'),
);

// const vdsRedesignshippingDetails = Loadable(() => import('../../containers/web/shippingDetailsVdsRedesign'));
export default MapTo('vcg/components/soe-home/react/vdsRedesignshippingDetails')(vdsRedesignshippingDetails);
